import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cake, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const MobileBirthdayBar = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("oddlytrue_bar_dismissed") === "1");
  const [shown, setShown] = useState(false);

  useEffect(() => { const t = setTimeout(() => setShown(true), 1200); return () => clearTimeout(t); }, []);

  if (hidden || (user && user.dob)) return null;
  const dismiss = () => { setHidden(true); sessionStorage.setItem("oddlytrue_bar_dismissed", "1"); };

  return (
    <>
      <div data-testid="mobile-birthday-bar" className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(env(safe-area-inset-bottom),10px)] transition-transform duration-500 ${shown ? "translate-y-0" : "translate-y-full"}`}>
        <div className="flex items-center gap-2 bg-ink text-white rounded-full pl-4 pr-1.5 py-1.5 shadow-[0_8px_30px_rgba(17,24,39,0.35)] border border-gold/40">
          <Cake className="w-4 h-4 text-gold shrink-0" />
          <Link to="/birthdays#twins" data-testid="mobile-birthday-bar-cta" className="flex-1 text-left text-[13px] font-semibold leading-tight py-1.5">See who shares <span className="text-gold">YOUR</span> birthday →</Link>
          <button type="button" data-testid="mobile-birthday-bar-dismiss" aria-label="Dismiss" onClick={dismiss} className="w-8 h-8 rounded-full flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </>
  );
};
